import React from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  InputGroup,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Spinner,
  Tag,
  TagCloseButton,
  TagLabel,
  Tooltip,
} from '@chakra-ui/react';
import _ from 'lodash';

export default function NumberChooserAndTracker({
  label,
  numberType,
  setNumberToAdd,
  addNumber,
  addNumberTooltip,
  canAddMoreNumbers,
  isLoading,
  workingNumberList,
  setNumberList,
  maxRecommendedNumber,
  minNumber,
  maxNumber,
}: {
  label: string;
  numberType: string;
  setNumberToAdd: React.Dispatch<React.SetStateAction<number>>;
  addNumber: () => void;
  addNumberTooltip: string;
  canAddMoreNumbers: boolean;
  isLoading: boolean;
  workingNumberList: number[];
  setNumberList: (numberList: number[]) => void;
  maxRecommendedNumber: number;
  minNumber: number;
  maxNumber: number;
}) {
  const pressEnterToAddNumber: React.KeyboardEventHandler<HTMLDivElement> = (
    event,
  ) => {
    if (event.key === 'Enter') {
      if (canAddMoreNumbers) {
        addNumber();
      }
    }
  };
  return (
    <FormControl isRequired>
      <FormLabel>{label}</FormLabel>
      <InputGroup>
        <HStack>
          <NumberInput
            defaultValue={minNumber}
            min={minNumber}
            max={maxNumber}
            onChange={(valueAsString, valueAsNumber) =>
              setNumberToAdd(valueAsNumber)
            }
            onKeyDown={pressEnterToAddNumber}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>

          <Tooltip
            hasArrow
            label={addNumberTooltip}
            isDisabled={canAddMoreNumbers}
            shouldWrapChildren
            mt="1"
          >
            <Button
              colorScheme="green"
              onClick={addNumber}
              isDisabled={!canAddMoreNumbers}
            >
              Add {numberType}
            </Button>
          </Tooltip>

          <Spinner
            m={4}
            thickness="4px"
            speed="1s"
            emptyColor="brand.miscUIEmptyColor"
            color="brand.miscUIColor"
            size="lg"
            hidden={!isLoading}
          />
          {workingNumberList.map((size) => (
            <Tag
              key={`${_.kebabCase(numberType)}-tag-${size}`}
              borderRadius="full"
              variant="solid"
              colorScheme={
                maxRecommendedNumber > 0 && size > maxRecommendedNumber
                  ? 'red'
                  : 'green'
              }
            >
              <TagLabel>{size}</TagLabel>
              <TagCloseButton
                onClick={() =>
                  setNumberList(_.without(workingNumberList, size))
                }
              />
            </Tag>
          ))}
        </HStack>
      </InputGroup>
    </FormControl>
  );
}
